import Axios from 'axios';

const GOOGLE_FONTS_API = 'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyDsgQOOM-7PyeGE3bSedUNYyQ9NTQvANMk';

let pending = null;

/**
 * Catalogue Google Fonts, `[{ key, familyName }]` comme `fontFamilyList` du
 * document (clé = nom aux espaces remplacés par `_`). Une seule requête par
 * session, partagée par tous les sélecteurs ; un échec permet de réessayer.
 */
export function fetchGoogleFontFamilies() {
  if (!pending) {
    pending = Axios.get(GOOGLE_FONTS_API)
      .then((res) => (res?.data?.items || []).map((family) => ({
        key: family.family.toString().replace(/\s+/g, '_'),
        familyName: family.family.toString(),
      })))
      .catch((error) => {
        pending = null;
        throw error;
      });
  }
  return pending;
}
